import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Button, Grid, Typography, CircularProgress, Divider, TextField, Box } from "@mui/material";
import { setShowImageGallery, setUploadedAssetObj, setSelectedImage } from 'store/slice/ImageGallerySlice';
import { getAPIprefix } from '../../../api/ApiUtils';
import assetAPI from './ImageGalleryAPI';
import { use } from 'react';

const ImageGalleryUploadNewImage = () => {
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadResult, setUploadResult] = useState("NA");
    const [errorMessage, setErrorMessage] = useState("");
    const [previewUrl, setPreviewUrl] = useState(null);
    const fileInputRef = useRef(null);

    const { uploadedAssetObj } = useSelector((state) => state.imagegalleryslice);
    const [apiInProgress, setApiInProgress] = useState(false);

    useEffect(() => {

    }, [uploadedAssetObj, apiInProgress])
    useEffect(() => {
        if (selectedFile === null) {
            handleButtonClick();
        }
    }, [])


    const handleFileChange = (event) => {
        setUploadResult('NA');
        setSelectedFile(event.target.files[0]);
        if (event.target.files[0]) {
            setPreviewUrl(URL.createObjectURL(event.target.files[0]));
        }
    };

    const handleButtonClick = () => {
        setUploadResult('NA');
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleAssetUploadSuccess = (responseObj) => {
        dispatch(setSelectedImage(responseObj.assetInfo))
        setApiInProgress(false)
        dispatch(setUploadedAssetObj(responseObj.assetInfo))
        setUploadResult("success");
        setSelectedFile(null);
        console.log("responseObj=>" + JSON.stringify(responseObj));
    }
    const handleAssetUploadFailure = (errorMsg) => {
        setApiInProgress(false);
        setUploadResult("failure");
        setErrorMessage(errorMsg);
        console.log("errorMsg=>" + errorMsg);
    }
    const handleSubmit = async (event) => {
        setUploadResult("NA");
        event.preventDefault();
        setApiInProgress(true);

        const formData = new FormData();
        formData.append('file', selectedFile);
        const token = localStorage.getItem("JWT");

        try {
            const response = await assetAPI.post('/extn/asset', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                },
            });

            console.log('File uploaded successfully:', response.data);
            handleAssetUploadSuccess(response.data)
        } catch (error) {
            console.error('Error uploading file:', error);
            // Check if error.response exists
            if (error.response) {
                if (error.response.status === 208) {
                    console.error('File upload already processed. No action taken.');
                } else {
                    console.error('Error uploading file:', error.response.data || error.message);
                    handleAssetUploadFailure(error.response.data || error.message)
                }
            } else {
                // If error.response is undefined
                console.error('Unexpected error occurred:', error.message || error);
                handleAssetUploadFailure(error.message || error)
            }

        }
    };
    const getMessage = () => {

        if (uploadResult === "failure") return <Typography color="error" gutterBottom><b><i>{errorMessage}</i></b></Typography>
        if (uploadResult === "success") return <Typography ><b><i>Uploaded successfully</i></b></Typography>

        //if (previewUrl) return <Typography ><b><i>Click on 'Upload' Button to upload selected image</i></b></Typography>
        if (previewUrl) return ''
        else return <Typography ><b><i>Click on 'Image from Local Machine' button to select an Image.</i></b></Typography>
    }
    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container direction="column" lg={12} sx={{ backgroundColor: 'white', height: '62vh', justifyContent: "center", alignItems: "center" }}>
                    <input type="file" accept="image/*,video/mp4" onChange={handleFileChange} ref={fileInputRef} style={{ display: 'none' }} />

                    <Grid item lg={8}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container sx={{ overflowY: "scroll", width: '100%', height: '62vh', justifyContent: "center", alignItems: "center" }}>
                                {previewUrl && (
                                    <div>
                                        {selectedFile && selectedFile.type === "video/mp4" ? (
                                            <video
                                                src={previewUrl}
                                                controls
                                                style={{ width: '100%', height: '100%' }}
                                            />
                                        ) : (
                                            <img src={previewUrl} alt="Selected" style={{ width: '100%', height: '100%' }} />
                                        )}
                                    </div>
                                )}
                                {!previewUrl && (
                                    <Grid container sx={{ justifyContent: "center", alignItems: "center" }}>
                                        <Grid sx={{ backgroundColor: '#e6f7ff', borderRadius: 5 }}>
                                            <Typography sx={{ padding: 2 }}><i>Click on 'Image From Local Machine' button for Image selection and then click on 'Upload' Button.</i></Typography>
                                        </Grid>

                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container direction="row" lg={12} xs={12} sx={{ justifyContent: "space-between", alignItems: "center", width: '100%'}}>
                    {!apiInProgress ?
                        <>
                            <Grid item lg={10} xs={12} sx={{ padding: 1 }}>
                                
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between" // Align buttons at extreme ends
                                    alignItems="center"
                                    sx={{ width: '100%', border: '1px solid #c4c4c4', borderRadius: 2, padding: 1 }}
                                >
                                    {uploadResult === "success"? <Grid item lg={6} xs={12} sx={{ textAlign: 'center', alignItems: 'center' }}>
                                        {getMessage()}
                                    </Grid>:<>
                                    
                                    <Grid item lg={3}>
                                        <Button
                                            variant="outlined"
                                            onClick={() => handleButtonClick()}
                                        >
                                            {selectedFile === null ? 'Image From Local Machine' : 'Change Image'}
                                        </Button>
                                    </Grid>
                                    <Grid item lg={3}>
                                        <Button
                                            variant="outlined"
                                            onClick={handleSubmit}
                                            disabled={!selectedFile}
                                        >
                                            Upload
                                        </Button>
                                    </Grid>
                                    <Grid item lg={6} xs={12} sx={{ textAlign: 'center', alignItems: 'center' }}>
                                        {getMessage()}
                                    </Grid>
                                    </>}

                                </Grid>
                            </Grid>
                            {/* <Grid item lg={2} xs={12} sx={{ padding: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" onClick={() => { dispatch(setShowImageGallery(true)) }}>
                                    Back to Gallery
                                </Button>
                            </Grid> */}
                        </>

                        : <>
                            <Grid item lg={8} container justifyContent="center" >
                                <CircularProgress />
                            </Grid>
                        </>}

                </Grid>
            </form>
        </>

    )
}
export default ImageGalleryUploadNewImage;